import { defineMessages } from '@atlassian/jira-intl'; // TODO - Port i18n string translations to new module ID keys

const messages: {
	tooltipAsc: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tooltipDesc: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	tooltipAsc: {
		id: 'issue-navigator.card-container.sort-button.tooltip-asc',
		defaultMessage: 'Sort ascending',
		description: '',
	},
	tooltipDesc: {
		id: 'issue-navigator.card-container.sort-button.tooltip-desc',
		defaultMessage: 'Sort descending',
		description: '',
	},
});
export default messages;
